import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState } from 'editor/src/store/design/types';

const removeSlotLayoutReducer = (
  state: DesignState,
  action: PayloadAction<{ spreadIndex: number; layoutId: string }>,
) => {
  const { spreadIndex, layoutId } = action.payload;
  const spread = state.designData?.spreads[spreadIndex];
  if (!spread?.slotLayouts) {
    return;
  }
  const layouts = spread.slotLayouts.filter((layout) => layout.id !== layoutId);
  spread.slotLayouts = layouts.length ? layouts : undefined;
};

export default removeSlotLayoutReducer;
